import { ReactNode, CSSProperties } from 'react';

export type BadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  style?: CSSProperties;
}

const VARIANTS: Record<BadgeVariant, CSSProperties> = {
  success: {
    background: 'var(--acc-badge-success-bg)',
    borderColor: 'var(--acc-badge-success-border)',
    color: 'var(--acc-badge-success-text)',
  },
  warning: {
    background: 'var(--acc-badge-warning-bg)',
    borderColor: 'var(--acc-badge-warning-border)',
    color: 'var(--acc-badge-warning-text)',
  },
  danger: {
    background: 'var(--acc-badge-danger-bg)',
    borderColor: 'var(--acc-badge-danger-border)',
    color: 'var(--acc-badge-danger-text)',
  },
  info: {
    background: 'var(--acc-badge-info-bg)',
    borderColor: 'var(--acc-badge-info-border)',
    color: 'var(--acc-badge-info-text)',
  },
  neutral: {
    background: 'var(--acc-badge-neutral-bg)',
    borderColor: 'var(--acc-badge-neutral-border)',
    color: 'var(--acc-badge-neutral-text)',
  },
};

export default function Badge({
  variant = 'neutral',
  children,
  style,
}: BadgeProps) {
  return (
    <span
      className={`acc-badge acc-badge--${variant}`}
      style={{
        textTransform: 'capitalize',
        ...VARIANTS[variant],
        ...style,
      }}
    >
      {children}
    </span>
  );
}
